export type ServiceId = 'data-foundations' | 'integrations' | 'applied-ai';

export interface Service {
  id: ServiceId;
  title: string;
  /** Short line used as an eyebrow or chip. */
  tagline: string;
  description: string;
  features: string[];
}

/**
 * The three core services, in the order the story tells them:
 * Data Foundations (Acts I–II) → Integrations (Act III) → Applied AI (Act IV).
 */
export const services: Service[] = [
  {
    id: 'data-foundations',
    title: 'Data Foundations',
    tagline: 'Build the foundation.',
    description:
      'AI only works if the data does. We build the platforms, pipelines, and quality layer Retail and CPG companies need to train, run, and trust AI—across products, channels, and customers.',
    features: ['Cloud data platforms', 'Retail & CPG data models', 'Data quality & governance'],
  },
  {
    id: 'integrations',
    title: 'Integrations',
    tagline: 'Connect the systems.',
    description:
      'Connect into the systems your teams already run—ERP, POS, e-commerce, planning, and marketing. Insights land where merchandisers, planners, and operators make decisions.',
    features: [
      'POS, ERP & e-commerce',
      'Planning & replenishment',
      'CDP & marketing platforms',
      'Custom APIs & workflows',
    ],
  },
  {
    id: 'applied-ai',
    title: 'Applied AI',
    tagline: 'Turn connections into action.',
    description:
      'We design and ship AI solutions that Retail and CPG teams actually use—demand forecasting, pricing, assortment, personalization, and supply chain. From use-case selection to production, we make AI pay off.',
    features: [
      'Use-case identification & ROI',
      'Forecasting, pricing & personalization',
      'Model development & evaluation',
      'Production deployment & monitoring',
    ],
  },
];

export const serviceById = (id: ServiceId): Service => {
  const match = services.find((service) => service.id === id);
  if (!match) throw new Error(`Unknown service: ${id}`);
  return match;
};
